import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import { useSelector } from "react-redux";
import { selectAccessToken } from "../redux/authSlice";
import LoadingModal from "./LoadingModal";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const accessToken = useSelector(selectAccessToken);

    useEffect(() => {

        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            } catch (err) {
                console.error(err);
            } finally {
                isMounted && setIsLoading(false);
            }
        }

        if (accessToken !== null) {
            setIsLoading(false);
        } else {
            verifyRefreshToken();
        }

        return () => {
            isMounted = false;
        }

    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {
                isLoading
                    ?
                    <LoadingModal />
                    :
                    <Outlet />
            }
        </>
    )
}

export default PersistLogin